import React from 'react';
import { db } from '../services/firebase';
import Highlighter from 'react-highlight-words';
import { Layout, Button, Row, Col, Space, Input, InputNumber, Upload, message, Table } from 'antd'
import { LoadingOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import firebase from 'firebase';
import { watcherVehiculos } from '../services/firebase/watcher'
import Modal from 'antd/lib/modal/Modal';

const { TextArea } = Input;
const { Content } = Layout;

const Vehicles = () => {
    //verificacion
    const [edit, setEdit] = React.useState(false)
    //crud
    const [id, setId] = React.useState(null)
    const [imageurl, setImageurl] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const [uploadValue, setUploadValue] = React.useState(1)
    const [vehiculos, setVehiculos] = React.useState([])
    const [marca, setMarca] = React.useState('')
    const [modelo, setModelo] = React.useState('')
    const [precio, setPrecio] = React.useState(1)
    const [vehiculo, setVehiculo] = React.useState({})
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 5,
    })

    const handleEdit = registro => {
        console.log(registro.id)
        setEdit(true)
        setId(registro.id)
        setMarca(registro.marca)
        setModelo(registro.modelo)
        setPrecio(registro.precio)
        setImageurl(registro.logo)
    }

    const columns = [
        {
            title: 'Marca',
            dataIndex: 'marca',
            key: 'marca',
        },
        {
            title: 'Modelo',
            dataIndex: 'modelo',
            key: 'modelo',
        },
        {
            title: 'Precio',
            dataIndex: 'precio',
            key: 'precio',
        },
        {
            title: "Foto",
            key: "foto",
            render: (text, record) => (
                <img src={record.logo} width='100' height='50' />
            )
        },
        {
            title: "Acciones",
            key: "action",
            render: (text, record) => (
                <Space direction='horizontal'>
                    <Button ghost type='primary' onClick={() => handleEdit(record)}>Editar</Button>
                    <span className="ant-divider" />
                    <Button ghost type='danger' onClick={() => db.collection('vehiculos').doc(record.id).delete().then(message.success('Registro eliminado con exito'))}>Eliminar</Button>
                </Space>
            )
        }
    ];

    const handleTableChange = (pagination, filters, sorter) => {
        setPagination(pagination)
    };



    React.useEffect(() => {
        watcherVehiculos(vehiculos => {
            setVehiculos(vehiculos)
        })
    }, []);

        const aggclub = async () => {
            let vehiculo = {
                marca: marca,
                modelo: modelo,
                precio: precio,
                logo: imageurl,
            };

            if (edit === true) {
                await db.collection('vehiculos').doc(id)
                    .set(vehiculo).then(() => {
                        message.success('Registro editado con exito')
                        setMarca('');
                        setModelo('');
                        setPrecio('');
                        setImageurl('');
                    })
            } else {
                await db.collection('vehiculos').add(vehiculo).then(() => {
                    message.success('Registro agregado con exito')
                    setMarca('');
                    setModelo('');
                    setPrecio('');
                    setImageurl('');
                })
            }
        }

        function beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                return message.error('Solo puedes subir archivos JPG o PNG!');
            }
            const isLt5M = (file.size / 1024 / 1024) < 2;
            if (isLt5M) {
                const storageRef = firebase.storage().ref(file.name);
                const task = storageRef.put(file);

                task.on('state_changed', (snapshot) => {
                    let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    setUploadValue(percentage);
                }, (error) => {
                    console.error(error.message)
                }, () => {
                    // Upload complete
                    setImageurl(task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        setImageurl(downloadURL)
                    }))
                    setLoading(false)
                })
            } else {
                message.error('El logo que intentas subir pesa mas de 2MB')
                setLoading(false)
            }
        }

        const handleChange = info => {
            //info.preventDefault()
            if (info.file.status === 'uploading') {
                setLoading(true)
                return;
            }
            //if (info.file.status === 'done') {
            //  // Get this url from response in real world.
            //  getBase64(info.file.originFileObj, imageUrl =>
            //    setImageurl(imageUrl),
            //    setLoading(false)
            //  );
            //}
        };

        const uploadButton = (
            <div>
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>Upload</div>
            </div>
        );

        return (
            <Layout>
                <Content
                    className="site-layout-background"
                    style={{
                        padding: 24,
                        margin: 0,
                        minHeight: 280,
                    }}
                >
                    <h1>WTI Services - Registro de vehiculos</h1>
                    <Row>
                        <Col span={12}>
                            <Space direction='vertical'>
                                <h4>Marca</h4>
                                <Input value={marca} onChange={e => setMarca(e.target.value)} />
                                <h4>Modelo</h4>
                                <TextArea autoSize value={modelo} onChange={e => setModelo(e.target.value)} />
                                <h4>Precio</h4>
                                <InputNumber style={{ width: '100%' }} min={1} max={999999999999} value={precio} onChange={e => setPrecio(e)} />
                            </Space>
                        </Col>
                        <Col span={12}>
                            <Space direction='vertical'>
                                <h4>Imagen (No mayor a 5mb)</h4>
                                <Upload
                                    name="avatar"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    beforeUpload={beforeUpload}
                                    onChange={e => handleChange(e)}
                                >
                                    {imageurl ? <img src={imageurl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                                </Upload>
                                <Button ghost onClick={() => aggclub()} type='primary' style={{ color: '#fff' }}>{edit === true ? 'Editar' : 'Agregar'}</Button>
                            </Space>
                        </Col>
                    </Row>
                    <hr />
                    <Table
                        dataSource={vehiculos}
                        columns={columns}
                        size='small'
                        pagination={pagination}
                        onChange={(a, b, c) => handleTableChange(a, b, c)}
                    />
                </Content>
            </Layout>
        )
    }

export default Vehicles


// WEBPACK FOOTER //
// ./src/pages/Vehicles.jsx